import React from 'react';
import { getBudgetWarnings, getRemaining, getTotalContracted, getTotalPayments } from '../../../utils/budgetUtils';

const BudgetWarningsSummary = ({ sortedScopes }) => {
  // Count budget warnings
  const outOfBudgetCount = sortedScopes.filter(scope => 
    scope.budget !== null && getRemaining(scope) < 0
  ).length;
  
  const contractsHigherThanBudgetCount = sortedScopes.filter(scope => 
    scope.budget && getTotalContracted(scope) > scope.budget
  ).length;
  
  const paymentsMoreThanContractedCount = sortedScopes.filter(scope => {
    const totalContracted = getTotalContracted(scope);
    const totalPaid = getTotalPayments(scope);
    return totalContracted > 0 && totalPaid > totalContracted;
  }).length;
  
  const noContractsCount = sortedScopes.filter(scope => 
    scope.budget && scope.budget > 0 && scope.contracts.length === 0
  ).length;
  
  // If no warnings, don't show the summary
  if (outOfBudgetCount === 0 && 
      contractsHigherThanBudgetCount === 0 && 
      paymentsMoreThanContractedCount === 0 && 
      noContractsCount === 0) {
    return null;
  }
  
  return (
    <tr className="bg-gray-50 dark:bg-gray-700 border-t border-gray-200 dark:border-gray-600">
      <td colSpan={7} className="py-3 pl-4 pr-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 sm:pl-6">
        <div className="flex flex-wrap gap-2">
          {outOfBudgetCount > 0 && (
            <span className="inline-flex items-center rounded-md bg-red-50 dark:bg-red-900/50 px-2 py-1 text-xs font-medium text-red-700 dark:text-red-300 ring-1 ring-inset ring-red-600/10 dark:ring-red-500/30">
              {outOfBudgetCount} scopes out of budget
            </span>
          )}
          {contractsHigherThanBudgetCount > 0 && (
            <span className="inline-flex items-center rounded-md bg-yellow-50 dark:bg-yellow-900/50 px-2 py-1 text-xs font-medium text-yellow-800 dark:text-yellow-300 ring-1 ring-inset ring-yellow-600/20 dark:ring-yellow-500/30">
              {contractsHigherThanBudgetCount} with contracts exceeding budget
            </span>
          )}
          {paymentsMoreThanContractedCount > 0 && (
            <span className="inline-flex items-center rounded-md bg-orange-50 dark:bg-orange-900/50 px-2 py-1 text-xs font-medium text-orange-700 dark:text-orange-300 ring-1 ring-inset ring-orange-600/10 dark:ring-orange-500/30">
              {paymentsMoreThanContractedCount} with payments exceeding contracts
            </span>
          )}
          {noContractsCount > 0 && (
            <span className="inline-flex items-center rounded-md bg-blue-50 dark:bg-blue-900/50 px-2 py-1 text-xs font-medium text-blue-700 dark:text-blue-300 ring-1 ring-inset ring-blue-700/10 dark:ring-blue-500/30">
              {noContractsCount} scopes without contracts
            </span>
          )}
        </div>
      </td>
    </tr>
  );
};

export default BudgetWarningsSummary;